import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { ageingPeriodAPI } from './AgeingPeriodAPI';
import { IAgeingPeriod } from './AgeingPeriodModel';

export interface IAgeingPeriodState {
  value: IAgeingPeriod[];
}

// deprecated, we're using the RTK query in apiSlice.ts for api calls now.

export const getAgedPeriodFromServerAction: any = createAsyncThunk(
  'agedPeriod/getAgedPeriodFromServerAction',
  async () => {
    const response = await ageingPeriodAPI();
    return response;
  },
);

export const slice = createSlice({
  name: 'agedPeriod',
  initialState: {
    value: {
      AgeingPeriod1: 0,
      AgeingPeriod2: 0,
      AgeingPeriod3: 0,
    },
  },
  reducers: {
    loadAgeingPeriodAction: (state, action: PayloadAction<IAgeingPeriod>) => {
      state.value = action.payload;
    },
  },
  extraReducers: {
    [getAgedPeriodFromServerAction.fulfilled]: (state, action: PayloadAction<IAgeingPeriod>) => {
      state.value = action.payload;
    },
  },
});

export const { loadAgeingPeriodAction } = slice.actions;
export const AgeingReducer = slice.reducer;
export const ageingPeriodList = (state: RootState) => state.agedPeriod.value;
